import React, { useEffect } from 'react';
import { isNil, range } from 'lodash';
import RuleCard from './RuleCard';
import Input from 'shared/inputs/BaseInput';
import { SPLIT_ON_TERM } from '../consts';
import useRulesContext from '../context';

const SplitOnTerm = () => {
  const {
    count, term, ruleTypeId, onTermChange, onRuleTypeChange, dispatch,
  } = useRulesContext();

  // Shift count to be user friendly - start with 1, but save with 0
  const realCount = isNil(count) ? null : count + 1;
  const onCountChange = ({ value }) => dispatch('setCount', value - 1);

  const isActive = ruleTypeId === SPLIT_ON_TERM;

  useEffect(() => {
    if (!isActive) {
      return;
    }
    dispatch('setValid', !!realCount && !!term && term.length > 0);
  }, [realCount, term]);

  const onClick = () => {
    dispatch('reset');
    onRuleTypeChange(SPLIT_ON_TERM);
  };

  return (
    <RuleCard isActive={isActive} onClick={onClick}>
      Split on
      {isActive && <Input autoFocus value={term} onChange={onTermChange} />}
      {!isActive && <span className='value-placeholder'>***</span>}
      and take
      {isActive && <Input customInput='numeric' min={1} value={realCount} onChange={onCountChange} />}
      {!isActive && <span className='value-placeholder'>N-th</span>}
      part
    </RuleCard>
  );
};

const SplitOnTermPreview = () => {
  const { count, term } = useRulesContext();
  const realCount = count + 1;

  const hasTerm = term && term.length > 0;

  if (!hasTerm) {
    return range(0, 10).map((ind) => (
      <div key={`preview-char-${ind}`} className={realCount === 1 ? 'preview-char included-char' : 'preview-char'} />
    ));
  }

  const groups = range(0, realCount - 1 || 1);

  return (
    <>
      {groups.map((ind) => (
        <>
          {range(0, 3).map((j) => (
            <div
              key={`preview-char-${j}`}
              className={ind === realCount - 1 ? 'preview-char included-char' : 'preview-char'}
            />
          ))}
          {term.split('').map((char) => (
            <div key={`preview-char-${char}-${ind}`} className='preview-char'>
              {char}
            </div>
          ))}
        </>
      ))}
      {range(0, 3).map((ind) => (
        <div
          key={`preview-char-${ind}`}
          className={realCount > groups.length ? 'preview-char included-char' : 'preview-char'}
        />
      ))}
    </>
  );
};

export default {
  RuleComponent: SplitOnTerm,
  PreviewComponent: SplitOnTermPreview,
  ruleTypesIds: [SPLIT_ON_TERM],
};
